import { isFeature } from 'Cloud/Application/FeaturesEs6';

export const includeFreeUsersInB2BOverquota = isFeature('include-free-users-in-b2b-overquota') || false;
